import $ from "jquery";
import '../../../node_modules/owl.carousel/dist/owl.carousel.min.js';

(function ($) {

  $(window).ready(function () {

    //	OWL CAROUSEL INITIALIZE
    $('.owl-carousel').owlCarousel({
      items: 1,
      loop: true,
      autoplay: true,
      autoplayTimeout: 4000,
      autoplayHoverPause: true,
    });

  });

})(jQuery);